var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { random, isIn, getCurrentTimeInSec, eqSet, isNil, isNilOrEmptyString, generateUUID, } from "../utils/Utils";
import { Token } from "./Token";
import { AppInfo } from "./AppInfo";
import { RoleInfo } from "./RoleInfo";
import axios from "axios";
import { KJUR, b64utoutf8 } from "jsrsasign";
import { Role } from "./Constants";
class TokenManager {
    constructor() {
        //accountId to tokenId to token
        this.tokensByTokenIdByAccountId = new Map();
        //accountId to tokenId to token
        this.tokensInProgressByTokenIdByAccountId = new Map();
        //accountId to App to AppInfo
        this.appInfoByAppByAccountId = new Map();
        //accountId to App to RoleInfo
        this.roleInfoByAppByAccountId = new Map();
        //accountId to App to tenantId to TenantInfo
        this.tenantInfoByTenantIdByAppByAccountId = new Map();
        //settings
        this.MAX_NUMBER_OF_TENANTS_PER_APP = new Map();
        this.associations = false;
        this.deleteToBeExpiredTokens = () => {
            for (const [accountId, tokens] of this.tokensByTokenIdByAccountId.entries()) {
                for (const [tokenId, token] of tokens.entries()) {
                    if (token.exp - getCurrentTimeInSec() <= this.TIME_BEFORE_EXPIRATION) {
                        if (this.isInTokensInProgress(token)) {
                            this.deleteToken(accountId, tokenId);
                        }
                        else {
                            this.renewToken(token);
                        }
                    }
                }
            }
            setTimeout(this.deleteToBeExpiredTokens, this.EXPIRATION_CHECK_INTERVAL * 1000);
        };
        // private constructor to enforce singleton-ness
        this.deleteToBeExpiredTokens();
    }
    static getInstance(appName) {
        if (this.instanceByApp.has(appName) &&
            this.instanceByApp.get(appName) !== null &&
            this.instanceByApp.get(appName) !== undefined) {
            return this.instanceByApp.get(appName);
        }
        else {
            this.instanceByApp.set(appName, new this());
            return this.instanceByApp.get(appName);
        }
    }
    static init(appName, maxNumberOfTenantsPerApp, expirationCheckInterval, timeBeforeExpiration, numberOfRetryForJwt, associations, mandatoryAssociations, optionalAssociations, fqdn, jwtAuth) {
        this.getInstance(appName);
        this.instanceByApp.get(appName).MAX_NUMBER_OF_TENANTS_PER_APP = maxNumberOfTenantsPerApp;
        this.instanceByApp.get(appName).EXPIRATION_CHECK_INTERVAL = expirationCheckInterval;
        this.instanceByApp.get(appName).TIME_BEFORE_EXPIRATION = timeBeforeExpiration;
        this.instanceByApp.get(appName).NUMBER_OF_RETRY_FOR_JWT = numberOfRetryForJwt;
        this.instanceByApp.get(appName).fqdn = fqdn;
        this.instanceByApp.get(appName).jwtAuth = jwtAuth;
        this.instanceByApp.get(appName).associations = associations;
        if (associations) {
            if (mandatoryAssociations.size === 0 && optionalAssociations.size === 0) {
                throw new Error(`you should provide associations!`);
            }
            else {
                this.instanceByApp.get(appName).mandatoryAssociations = mandatoryAssociations;
                this.instanceByApp.get(appName).optionalAssociations = optionalAssociations;
            }
        }
    }
    getMaxNumberOfTenantsPerApp() {
        return this.MAX_NUMBER_OF_TENANTS_PER_APP;
    }
    hasTenant(accountId, tenantId, app) {
        let tenantInfoByTenantIdByApp = new Map();
        if (!this.tenantInfoByTenantIdByAppByAccountId.has(accountId)) {
            throw new Error(`No info for accountId ${accountId}`);
        }
        else {
            tenantInfoByTenantIdByApp = this.tenantInfoByTenantIdByAppByAccountId.get(accountId);
            if (!tenantInfoByTenantIdByApp.has(app) ||
                !tenantInfoByTenantIdByApp.get(app).has(tenantId)) {
                return false;
            }
            else {
                return true;
            }
        }
    }
    getTenantRegion(accountId, tenantId, app) {
        if (this.hasTenant(accountId, tenantId, app)) {
            const tenantInfo = this.tenantInfoByTenantIdByAppByAccountId
                .get(accountId)
                .get(app)
                .get(tenantId);
            if (isNil(tenantInfo.region)) {
                // throw new Error(
                //     `Region for accountId ${accountId}, app ${app}, ` +
                //         `tenantId ${tenantId} is ` +
                //         `${
                //             this.tenantInfoByTenantIdByAppByAccountId
                //                 .get(accountId)
                //                 .get(app)
                //                 .get(tenantId).region
                //         }`,
                // );
                return null;
            }
            else {
                return tenantInfo.region;
            }
        }
    }
    getAssociatedTenantRegion(accountId, app, appTenantId, associatedApp, associatedAppTenantId) {
        if (this.hasTenant(accountId, appTenantId, app)) {
            const tenantInfo = this.tenantInfoByTenantIdByAppByAccountId
                .get(accountId)
                .get(app)
                .get(appTenantId);
            if (isNil(tenantInfo.associations) ||
                Object.keys(tenantInfo.associations).length === 0) {
                // throw new Error(`No associastion for accountId ${accountId}, app ${app}! `);
                return null;
            }
            else {
                if (isNil(tenantInfo.associations[associatedApp]) ||
                    tenantInfo.associations[associatedApp]["tenant_id"] !== associatedAppTenantId) {
                    // throw new Error(
                    //     `No associastion for accountId ${accountId}, app ${app} tenantId ${appTenantId} ` +
                    //         `with app ${associatedApp} tenantId ${associatedAppTenantId} `,
                    // );
                    return null;
                }
                else {
                    return tenantInfo.associations[associatedApp]["region"];
                }
            }
        }
    }
    getAnyExistingJwt(accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            let jwt;
            if (this.tokensByTokenIdByAccountId.has(accountId) &&
                this.tokensByTokenIdByAccountId.get(accountId).size > 0) {
                for (const token of this.tokensByTokenIdByAccountId.get(accountId).values()) {
                    if (token.hasJwt && token.exp > getCurrentTimeInSec()) {
                        jwt = token.jwt;
                    }
                }
            }
            return jwt;
        });
    }
    getJwt(accountId, requestedTenantByApp) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.processJwt(accountId, requestedTenantByApp);
        });
    }
    setAuth(authData) {
        const credentials = authData.credentials;
        const entitlements = authData.entitlements;
        const accountId = authData.accountInfo.accountId;
        this.userEmail = authData.userData.email;
        this.setRoleInfo(credentials);
        this.setTenantInfo(accountId, entitlements);
        this.setAppInfo(accountId);
    }
    processJwt(accountId, requestedTenantByApp) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestedTenantByApp.size > this.MAX_NUMBER_OF_TENANTS_PER_APP.size) {
                throw new Error(`Number Apps exceeds maximum number ${this.MAX_NUMBER_OF_TENANTS_PER_APP.size}` +
                    ` that is allowed in the token.`);
            }
            for (const [app, requestestedTenants] of requestedTenantByApp.entries()) {
                if (!this.MAX_NUMBER_OF_TENANTS_PER_APP.has(app)) {
                    throw new Error(`The ${app} app is not in the list of allowed apps in token payload.`);
                }
                if (requestestedTenants.size > this.MAX_NUMBER_OF_TENANTS_PER_APP.get(app)) {
                    throw new Error(`Number of tenantIds exceeds maximum number ${this.MAX_NUMBER_OF_TENANTS_PER_APP.get(app)}` + ` that is allowed in the token for ${app}.`);
                }
            }
            if (this.tokensByTokenIdByAccountId.has(accountId)) {
                for (const token of this.tokensByTokenIdByAccountId.get(accountId).values()) {
                    if (token.hasJwt) {
                        if (token.exp > getCurrentTimeInSec()) {
                            let hasAllTenants = true;
                            for (const [app, requestedTenants] of requestedTenantByApp.entries()) {
                                // check if it has all apps
                                if (!token.appInfoByApp.has(app)) {
                                    hasAllTenants = false;
                                    break;
                                }
                                // check if it has all tenants in apps
                                if (!isIn(requestedTenants, new Set(token.appInfoByApp.get(app).tenants))) {
                                    hasAllTenants = false;
                                    break;
                                }
                                // check if it has all associations for tenants in apps
                                if (this.associations) {
                                    if (this.mandatoryAssociations.has(app)) {
                                        const mandatoryAssociations = this.mandatoryAssociations.get(app);
                                        if (isNil(token.appInfoByApp.get(app).associations) ||
                                            token.appInfoByApp.get(app).associations.length === 0) {
                                            hasAllTenants = false;
                                            break;
                                        }
                                        for (const association of token.appInfoByApp.get(app)
                                            .associations) {
                                            for (const mandatoryAssociation of mandatoryAssociations) {
                                                if (!association.has(mandatoryAssociation)) {
                                                    hasAllTenants = false;
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            if (hasAllTenants) {
                                return token.jwt;
                            }
                        }
                        else {
                            this.deleteToken(accountId, token.id);
                            // Warning, shouldnt have expired token in this list.
                        }
                    }
                }
            }
            const token = this.generateTokenOnlyForRequestedTenants(accountId, requestedTenantByApp);
            this.addToTokensInProgress(token);
            if (this.associations) {
                this.addAssociations(token);
            }
            const signedToken = yield this.signToken(token);
            let tokensByTokenId = new Map();
            if (this.tokensByTokenIdByAccountId.has(accountId)) {
                tokensByTokenId = this.tokensByTokenIdByAccountId.get(accountId);
            }
            tokensByTokenId.set(signedToken.id, signedToken);
            this.tokensByTokenIdByAccountId.set(signedToken.accountId, tokensByTokenId);
            this.deleteFromTokensInProgress(signedToken);
            return signedToken.jwt;
        });
    }
    addAssociations(token) {
        for (const [app, appInfo] of token.appInfoByApp) {
            const associations = new Array();
            const tenantInfo = this.tenantInfoByTenantIdByAppByAccountId
                .get(token.accountId)
                .get(app);
            const tenants = appInfo.tenants;
            let hasAnyAssociation = false;
            for (const tenant of tenants) {
                const associationMap = new Map();
                for (const mandatoryAssociation of this.mandatoryAssociations.get(app)) {
                    if (isNilOrEmptyString(tenantInfo.get(tenant).associations[mandatoryAssociation]) ||
                        isNilOrEmptyString(tenantInfo.get(tenant).associations[mandatoryAssociation]["tenant_id"])) {
                        throw new Error(`Association between ${app} and ${mandatoryAssociation} is mandatory.` +
                            ` Couldn't find any for tenantId ${tenant}`);
                    }
                    associationMap.set(mandatoryAssociation, tenantInfo.get(tenant).associations[mandatoryAssociation]["tenant_id"]);
                    hasAnyAssociation = true;
                }
                for (const optionalAssociation of this.optionalAssociations.get(app)) {
                    if (!isNilOrEmptyString(tenantInfo.get(tenant).associations[optionalAssociation]) &&
                        !isNilOrEmptyString(tenantInfo.get(tenant).associations[optionalAssociation]["tenant_id"])) {
                        associationMap.set(optionalAssociation, tenantInfo.get(tenant).associations[optionalAssociation]["tenant_id"]);
                        hasAnyAssociation = true;
                    }
                }
                associations.push(associationMap);
            }
            if (hasAnyAssociation) {
                appInfo.associations = associations;
            }
        }
    }
    setTenantInfo(accountId, entitlements) {
        for (const app of this.MAX_NUMBER_OF_TENANTS_PER_APP.keys()) {
            if (!isNil(entitlements[app])) {
                const tenantsInfo = new Map();
                for (const tenant of entitlements[app].tenants) {
                    tenantsInfo.set(tenant.tenant_id, tenant);
                }
                if (tenantsInfo.size > 0) {
                    if (this.tenantInfoByTenantIdByAppByAccountId.has(accountId)) {
                        this.tenantInfoByTenantIdByAppByAccountId
                            .get(accountId)
                            .set(app, tenantsInfo);
                    }
                    else {
                        this.tenantInfoByTenantIdByAppByAccountId.set(accountId, new Map([[app, tenantsInfo]]));
                    }
                }
                // else {
                //     throw new Error(`No tenants for account ${accountId}, ${app} in the entitlements.`);
                // }
            }
        }
    }
    setRoleInfo(credentials) {
        for (const accountInfo of credentials.supportAccountIds) {
            if (accountInfo.rbacRoles !== null && accountInfo.rbacRoles !== undefined) {
                const rbacRoles = accountInfo.rbacRoles;
                const accountID = accountInfo.accountid;
                const rbacRolesKeys = Object.keys(rbacRoles);
                if (rbacRolesKeys.length > 0) {
                    if (rbacRolesKeys.length === 1 &&
                        rbacRolesKeys[0] === Role.ACCOUNT_SUPER_USER) {
                        for (const app of this.MAX_NUMBER_OF_TENANTS_PER_APP.keys()) {
                            let roleInfoByAppId = new Map();
                            if (this.roleInfoByAppByAccountId.has(accountID)) {
                                roleInfoByAppId = this.roleInfoByAppByAccountId.get(accountID);
                            }
                            roleInfoByAppId.set(app, new RoleInfo(accountID, Role.ACCOUNT_SUPER_USER));
                            this.roleInfoByAppByAccountId.set(accountID, roleInfoByAppId);
                        }
                    }
                    else {
                        for (const app of this.MAX_NUMBER_OF_TENANTS_PER_APP.keys()) {
                            if (!isNil(rbacRoles[app])) {
                                this.addRoleInfo(accountID, rbacRoles, app);
                            }
                        }
                    }
                }
            }
            else {
                throw new Error(`undefined rbacRoles`);
            }
        }
    }
    setAppInfo(accountId) {
        let hasRole = false;
        if (!this.tenantInfoByTenantIdByAppByAccountId.has(accountId)) {
            throw new Error(`user does not have accountId: ${accountId}`);
        }
        for (const app of this.tenantInfoByTenantIdByAppByAccountId.get(accountId).keys()) {
            if (this.roleInfoByAppByAccountId.has(accountId) &&
                this.roleInfoByAppByAccountId.get(accountId).has(app)) {
                hasRole = true;
            }
        }
        if (!hasRole) {
            throw new Error(`no role found for account ${accountId}`);
        }
        for (const app of this.tenantInfoByTenantIdByAppByAccountId.get(accountId).keys()) {
            if (this.roleInfoByAppByAccountId.has(accountId) &&
                this.roleInfoByAppByAccountId.get(accountId).has(app)) {
                this.addAppInfo(accountId, app);
            }
        }
    }
    addRoleInfo(accountId, rbacRoles, app) {
        if (rbacRoles[app] !== null && rbacRoles[app] !== undefined) {
            const roleInfo = new RoleInfo(accountId);
            if (this.roleInfoByAppByAccountId.has(accountId)) {
                this.roleInfoByAppByAccountId.get(accountId).set(app, roleInfo);
            }
            else {
                this.roleInfoByAppByAccountId.set(accountId, new Map([[app, roleInfo]]));
            }
            const appRoles = rbacRoles[app];
            const appRolesKeys = Object.keys(appRoles);
            if (appRolesKeys.length > 0) {
                const firstKey = appRolesKeys[0];
                if (firstKey === Role.APP_ADMIN) {
                    roleInfo.role = firstKey;
                }
                else {
                    for (const tenantID of appRolesKeys) {
                        const roleObject = appRoles[tenantID];
                        roleInfo.rolesByTenantId.set(tenantID, Object.keys(roleObject)[0]);
                    }
                }
            }
            else {
                throw new Error(`empty roles.`);
            }
        }
    }
    addAppInfo(accountId, app) {
        const tenantIds = new Array();
        const roles = new Array();
        const appInfo = new AppInfo();
        const roleInfo = this.roleInfoByAppByAccountId.get(accountId).get(app);
        if (this.appInfoByAppByAccountId.has(accountId)) {
            this.appInfoByAppByAccountId.get(accountId).set(app, appInfo);
        }
        else {
            this.appInfoByAppByAccountId.set(accountId, new Map([[app, appInfo]]));
        }
        for (const tenantId of this.tenantInfoByTenantIdByAppByAccountId
            .get(accountId)
            .get(app)
            .keys()) {
            tenantIds.push(tenantId);
            roles.push(roleInfo.rolesByTenantId.get(tenantId));
        }
        if (roles.length === 0 && roleInfo.role === "") {
            throw new Error(`accountId: ${accountId} does not have any role for ${app}`);
        }
        appInfo.setAppInfo(tenantIds, roles.length > 0 ? roles : undefined, roleInfo.role);
    }
    generateTokenOnlyForRequestedTenants(accountId, requestedTenantsByApp) {
        const appsInToken = new Array();
        for (const [app, max] of this.MAX_NUMBER_OF_TENANTS_PER_APP.entries()) {
            if (this.appInfoByAppByAccountId.get(accountId).has(app) &&
                requestedTenantsByApp.has(app)) {
                appsInToken.push(app);
            }
        }
        const token = new Token(accountId, appsInToken, this.userEmail);
        for (const [app, max] of this.MAX_NUMBER_OF_TENANTS_PER_APP.entries()) {
            if (requestedTenantsByApp.has(app) &&
                !this.appInfoByAppByAccountId.get(accountId).has(app)) {
                throw new Error(`No info found for requested app ${app}.`);
            }
            if (this.appInfoByAppByAccountId.get(accountId).has(app)) {
                const appInfo = this.appInfoByAppByAccountId.get(accountId).get(app);
                const tenants = new Set(appInfo.tenants);
                if (!requestedTenantsByApp.has(app)) {
                    requestedTenantsByApp.set(app, new Set());
                }
                const requestedTenats = requestedTenantsByApp.get(app);
                if (!isIn(requestedTenats, tenants)) {
                    throw new Error(`Some or all the tenantIds ` + ` are not valid for ${app}`);
                }
                for (let i = 0; i < appInfo.tenants.length; i++) {
                    if (requestedTenats.has(appInfo.tenants[i])) {
                        token.appInfoByApp
                            .get(app)
                            .addFromAppInfo(this.appInfoByAppByAccountId.get(accountId).get(app), i);
                    }
                }
            }
        }
        return token;
    }
    signToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            let numberOfTry = 0;
            const postBody = {
                supportAccountId: token.accountId,
                jti: token.id,
                userEmail: token.userEmail,
                apps: token.mapAppInfoByAppToObject(),
            };
            while (numberOfTry < this.NUMBER_OF_RETRY_FOR_JWT) {
                try {
                    let options;
                    if (!isNilOrEmptyString(this.jwtAuth)) {
                        options = {
                            headers: { "x-auth-jwt": this.jwtAuth, "token-request-id": generateUUID() },
                        };
                    }
                    else {
                        options = {
                            headers: { "token-request-id": generateUUID() },
                        };
                    }
                    let url = "/xseer/getToken";
                    if (!isNilOrEmptyString(this.fqdn)) {
                        url = this.fqdn;
                    }
                    const result = yield axios.post(url, postBody, options);
                    const jwt = result.data.token;
                    const resultObject = KJUR.jws.JWS.readSafeJSONString(b64utoutf8(jwt.split(".")[1]));
                    token.jwt = jwt;
                    token.hasJwt = true;
                    token.iat = resultObject.iat;
                    token.exp = resultObject.exp;
                    token.sessionId = resultObject.sessionId;
                    token.comingFromAppId = resultObject.comingFromAppId;
                    token.userEmail = resultObject.userEmail;
                    return token;
                }
                catch (error) {
                    numberOfTry++;
                    if (numberOfTry >= this.NUMBER_OF_RETRY_FOR_JWT) {
                        throw new Error(error);
                    }
                }
            }
        });
    }
    renewToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const newToken = new Token(token.accountId, Array.from(token.appInfoByApp.keys()), token.userEmail);
            newToken.appInfoByApp = token.appInfoByApp;
            this.addToTokensInProgress(newToken);
            const signedToken = yield this.signToken(newToken);
            if (this.tokensByTokenIdByAccountId.has(signedToken.accountId)) {
                this.tokensByTokenIdByAccountId
                    .get(signedToken.accountId)
                    .set(signedToken.id, signedToken);
            }
            else {
                this.tokensByTokenIdByAccountId.set(signedToken.accountId, new Map([[signedToken.id, signedToken]]));
            }
            this.deleteToken(token.accountId, token.id);
            this.deleteFromTokensInProgress(newToken);
        });
    }
    addToTokensInProgress(token) {
        if (this.tokensInProgressByTokenIdByAccountId.has(token.accountId)) {
            this.tokensInProgressByTokenIdByAccountId.get(token.accountId).set(token.id, token);
        }
        else {
            this.tokensInProgressByTokenIdByAccountId.set(token.accountId, new Map([[token.id, token]]));
        }
    }
    deleteFromTokensInProgress(token) {
        const accountId = token.accountId;
        this.tokensInProgressByTokenIdByAccountId.get(accountId).delete(token.id);
        if (this.tokensInProgressByTokenIdByAccountId.get(accountId).size === 0) {
            this.tokensInProgressByTokenIdByAccountId.delete(token.accountId);
        }
    }
    isInTokensInProgress(token) {
        if (this.tokensInProgressByTokenIdByAccountId.has(token.accountId)) {
            for (const inProgressToken of this.tokensInProgressByTokenIdByAccountId
                .get(token.accountId)
                .values()) {
                if (this.eqToken(inProgressToken, token)) {
                    return true;
                }
            }
        }
        return false;
    }
    eqToken(firstToken, secondToken) {
        if (firstToken.appInfoByApp.size !== secondToken.appInfoByApp.size) {
            return false;
        }
        if (!eqSet(new Set(firstToken.appInfoByApp.keys()), new Set(secondToken.appInfoByApp.keys()))) {
            return false;
        }
        for (const [app, appInfo] of firstToken.appInfoByApp.entries()) {
            if (!eqSet(new Set(appInfo.tenants), new Set(secondToken.appInfoByApp.get(app).tenants))) {
                return false;
            }
        }
        return true;
    }
    deleteToken(accountId, tokenId) {
        this.tokensByTokenIdByAccountId.get(accountId).delete(tokenId);
        if (this.tokensByTokenIdByAccountId.get(accountId).size === 0) {
            this.tokensByTokenIdByAccountId.delete(accountId);
        }
    }
    pickRandomTenantIdIndex(indicesSet) {
        const indexAvailable = random(indicesSet.size);
        const tenantIdIndex = [...indicesSet][indexAvailable];
        indicesSet.delete(tenantIdIndex);
        return tenantIdIndex;
    }
}
TokenManager.instanceByApp = new Map();
export default TokenManager;
